export const API_BASE_URL = process.env.GATSBY_MIDDLEWARE_BASE_URL
export const DEFAULT_HEADERS = {
	'Content-Type': 'application/json; charset=utf-8',
}
